{
  "sidebar": {
    "dashboard": "Панель управления",
    "reports": "Посещаемость",
    "devices": "Устройства",
    "employees": "Сотрудники",
    "entriesExits": "Приходы/уходы",
    "users": "Пользователи",
    "settings": "Настройки",
    "branding": "Брендинг",
    "workSchedule": "График работы",
    "holidays": "Праздники",
    "timeOff": "Отпуска",
    "collapse": "Свернуть",
    "expand": "Развернуть меню"
  },
  "users": {
    "title": "Пользователи",
    "addNew": "+ Новый пользователь",
    "filters": {
      "allRoles": "Все роли",
      "user": "Пользователь",
      "admin": "Администратор",
      "superAdmin": "Суперадминистратор"
    },
    "filterByRole": "Фильтр по роли",
    "failedToLoad": "Не удалось загрузить данные. Пожалуйста, попробуйте снова.",
    "empty": "Пользователей пока нет.",
    "columns": {
      "name": "Имя",
      "email": "Email",
      "role": "Роль",
      "status": "Статус",
      "devices": "Устройства",
      "created": "Создан",
      "actions": "Действия"
    },
    "actions": {
      "edit": "Изменить",
      "resetPassword": "Сбросить пароль",
      "delete": "Удалить"
    },
    "selfManageHint": "Нельзя управлять собственным аккаунтом — используйте верхнюю панель",
    "confirm": {
      "delete": "Удалить пользователя {{name}}?"
    }
  },
  "schedule": {
    "title": "График работы",
    "subtitle": "Задайте стандартное рабочее время для вашей компании. Продолжительность перерыва автоматически вычитается из отработанного времени каждого сотрудника.",
    "sectionTitle": "Рабочие часы",
    "shiftStart": "Начало работы",
    "shiftEnd": "Конец рабочего дня",
    "breakMinutes": "Перерыв",
    "minutes": "минут",
    "breakHint": "Фиксированный неоплачиваемый перерыв, вычитаемый из отработанного времени каждый день.",
    "saving": "Сохранение…",
    "submit": "Сохранить график",
    "success": "График работы обновлён.",
    "failed": "Не удалось сохранить график. Пожалуйста, попробуйте снова.",
    "lateGrace": "Допустимое опоздание (минуты)",
    "lateGraceHint": "Опоздание в пределах этого числа минут не штрафуется",
    "lateDeductionPercent": "Удержание за опоздание (% от часовой ставки)",
    "lateDeductionHint": "Процент от часовой ставки, удерживаемый за минуты опоздания сверх допустимого. 0 = полная часовая ставка (100%)",
    "lateDeductionFixed": "Удерживать фиксированную сумму вместо процента",
    "lateDeductionFixedHint": "Если включено, используется фиксированная сумма ниже вместо процента.",
    "lateDeductionAmount": "Фиксированное удержание за час опоздания (AMD)",
    "lateDeductionAmountHint": "Удерживается за каждый час опоздания сверх допустимого (напр. 1000 → опоздание 2 ч = 2000).",
    "workingDays": "Рабочие дни",
    "workingDaysHint": "Выберите, какие дни недели являются рабочими. Должен быть выбран хотя бы один день.",
    "days": {
      "mon": "Пн",
      "tue": "Вт",
      "wed": "Ср",
      "thu": "Чт",
      "fri": "Пт",
      "sat": "Сб",
      "sun": "Вс"
    },
    "errors": {
      "invalidTime": "Введите корректное время (ЧЧ:ММ).",
      "invalidBreak": "Перерыв должен быть целым числом минут (0 или больше).",
      "invalidGrace": "Введите неотрицательное целое число",
      "invalidDeduction": "Введите процент от 0 до 100",
      "invalidAmount": "Введите неотрицательную сумму",
      "noWorkingDays": "Выберите хотя бы один рабочий день."
    },
    "latenessSection": "Правила опозданий",
    "daysPerWeek": "Рабочих дней в неделю (плавающий выходной)",
    "daysPerWeekOff": "Выключено — по отмеченным дням",
    "daysPerWeekHint": "Например 6: один непроставленный день в неделю автоматически засчитывается как выходной (X), без вычета. Значение в карточке сотрудника имеет приоритет."
  },
  "branding": {
    "title": "Брендинг",
    "subtitle": "Эти настройки применяются к интерфейсу вашей компании, PDF-отчётам и email-уведомлениям.",
    "logo": {
      "sectionTitle": "Логотип компании",
      "upload": "Загрузить новый логотип",
      "hint": "PNG, JPG или SVG. Макс. 512 КБ.",
      "errorType": "Принимаются только файлы PNG, JPG и SVG.",
      "errorSize": "Файл должен быть не более 512 КБ.",
      "uploading": "Загрузка…",
      "submit": "Загрузить логотип",
      "ariaCurrentLogo": "Текущий логотип для {{name}}",
      "noLogo": "Логотип ещё не загружен.",
      "success": "Логотип успешно обновлён.",
      "failed": "Не удалось загрузить логотип. Пожалуйста, попробуйте снова."
    },
    "color": {
      "sectionTitle": "Цвет бренда",
      "label": "Основной цвет",
      "ariaLabel": "Выбрать основной цвет бренда",
      "saving": "Сохранение…",
      "submit": "Сохранить цвет",
      "success": "Цвет бренда обновлён.",
      "failed": "Не удалось обновить цвет. Пожалуйста, попробуйте снова."
    }
  },
  "editWebUserDialog": {
    "titleNew": "Новый пользователь",
    "titleEdit": "Изменить пользователя — {{name}}",
    "nameLabel": "Имя",
    "namePlaceholder": "Полное имя",
    "emailLabel": "Email",
    "emailPlaceholder": "user@example.com",
    "passwordLabel": "Пароль",
    "passwordPlaceholder": "Минимум 8 символов",
    "roleLabel": "Роль",
    "activeLabel": "Активен",
    "cannotDeactivateSelf": "(нельзя деактивировать себя)",
    "cannotChangeOwnRole": "Нельзя изменить собственную роль. Используйте другой аккаунт суперадмина.",
    "saveFailed": "Не удалось сохранить"
  },
  "resetWebUserPasswordDialog": {
    "title": "Сброс пароля",
    "subtitle": "Задание нового пароля для {{name}}.",
    "newPasswordLabel": "Новый пароль",
    "confirmPasswordLabel": "Подтвердите пароль",
    "newPasswordPlaceholder": "Минимум 8 символов",
    "confirmPasswordPlaceholder": "Повторите новый пароль",
    "errors": {
      "tooShort": "Пароль должен содержать не менее 8 символов.",
      "mismatch": "Пароли не совпадают.",
      "failed": "Не удалось сбросить пароль. Пожалуйста, попробуйте снова."
    },
    "submit": "Сбросить пароль",
    "submitting": "Сброс…"
  },
  "platform": {
    "pagination": {
      "of": "из",
      "previous": "Предыдущая страница",
      "next": "Следующая страница"
    },
    "common": {
      "loading": "Загрузка…",
      "searchCompanies": "Поиск компаний",
      "searchUsers": "Поиск пользователей",
      "searchDevices": "Поиск устройств",
      "filterByCompany": "Фильтр по компании",
      "filterByRole": "Фильтр по роли",
      "filterByStatus": "Фильтр по статусу",
      "devAbbr": "уст."
    },
    "roleBadge": "Платформ-Админ",
    "consoleSubtitle": "Консоль платформы",
    "orders": {
      "title": "Заявки",
      "subtitle": "Заявки на демо, отправленные с лендинга",
      "empty": "Заявок пока нет",
      "emptyHint": "Заявки, отправленные через форму на лендинге, появятся здесь.",
      "failedToLoad": "Не удалось загрузить заявки",
      "columns": {
        "date": "Дата",
        "name": "Имя",
        "contacts": "Контакты",
        "company": "Компания",
        "message": "Сообщение",
        "status": "Статус"
      },
      "status": {
        "all": "Все",
        "new": "Новая",
        "contacted": "Связались",
        "closed": "Закрыта"
      },
      "statusUpdated": "Статус обновлён.",
      "statusUpdateFailed": "Не удалось обновить статус."
    },
    "companies": {
      "title": "Компании",
      "subtitle": "Все компании-клиенты платформы",
      "addNew": "+ Новая компания",
      "searchPlaceholder": "Поиск компаний…",
      "failedToLoad": "Не удалось загрузить компании",
      "empty": "Компаний пока нет",
      "emptyHint": "Нажмите + Новая компания для добавления первого арендатора.",
      "columns": {
        "name": "Имя",
        "slug": "Идентификатор",
        "status": "Статус",
        "rate": "Тариф/мес",
        "employees": "Сотрудники",
        "users": "Пользователи",
        "devices": "Устройства",
        "created": "Создана",
        "actions": "Действия"
      },
      "badges": {
        "suspended": "Приостановлена",
        "active": "Активна"
      },
      "actions": {
        "reactivating": "Восстановление…",
        "reactivate": "Восстановить",
        "suspending": "Приостановка…",
        "suspend": "Приостановить",
        "delete": "Удалить"
      },
      "toasts": {
        "suspended": "Компания приостановлена.",
        "reactivated": "Компания восстановлена.",
        "suspendFailed": "Не удалось приостановить компанию. Пожалуйста, попробуйте снова.",
        "reactivateFailed": "Не удалось восстановить компанию. Пожалуйста, попробуйте снова.",
        "deleted": "Компания удалена.",
        "deleteFailed": "Не удалось удалить компанию. Пожалуйста, попробуйте снова."
      },
      "confirm": {
        "suspend": "Приостановить компанию {{name}}? Пользователи потеряют доступ.",
        "reactivate": "Восстановить компанию {{name}}?",
        "delete": "Удалить компанию {{name}}? Это нельзя отменить из интерфейса."
      },
      "editAriaLabel": "Изменить {{name}}",
      "deleteAriaLabel": "Удалить {{name}}"
    },
    "companyEmployees": {
      "back": "Назад к компаниям",
      "title": "{{company}} — сотрудники",
      "titleFallback": "Сотрудники компании",
      "total": "Всего: {{count}}",
      "searchPlaceholder": "Поиск по имени или PIN…",
      "loadFailed": "Не удалось загрузить сотрудников.",
      "empty": "У этой компании пока нет сотрудников.",
      "emptySearch": "По запросу сотрудники не найдены.",
      "columns": {
        "name": "Сотрудник",
        "card": "Карта",
        "status": "Статус",
        "hired": "Принят"
      },
      "badges": {
        "active": "Активен",
        "inactive": "Неактивен"
      },
      "sync": "Синхронизировать с терминалом",
      "syncing": "Синхронизация…",
      "syncQueued": "Поставлено {{commands}} команд на {{devices}} терминал(ов). Список скоро обновится.",
      "syncFailed": "Не удалось запустить синхронизацию. Проверьте, что у компании есть активные терминалы.",
      "editDialog": {
        "title": "Изменить сотрудника",
        "subtitle": "Изменения сохраняются в приложении и отправляются на терминалы компании.",
        "nameLabel": "Полное имя",
        "cardLabel": "Карта",
        "emailLabel": "Email",
        "phoneLabel": "Телефон",
        "activeLabel": "Активен",
        "pinHint": "Должен быть уникален в пределах компании.",
        "pinTaken": "Этот PIN уже занят в этой компании.",
        "pushNotice": "Обновлённая запись будет автоматически отправлена на терминалы.",
        "save": "Сохранить",
        "saving": "Сохранение…",
        "saved": "Сотрудник обновлён, изменения отправлены на терминалы.",
        "saveFailed": "Не удалось обновить сотрудника. Попробуйте снова."
      }
    },
    "createCompanyDialog": {
      "title": "Новая компания",
      "companyNameLabel": "Название компании *",
      "slugLabel": "Идентификатор * (предлагается автоматически)",
      "adminSectionTitle": "Первый аккаунт администратора",
      "adminEmailLabel": "Email администратора *",
      "adminNameLabel": "Имя администратора *",
      "adminPasswordLabel": "Пароль администратора (оставьте пустым для автогенерации)",
      "monthlyRateLabel": "Месячный тариф (AMD)",
      "monthlyRateHelp": "Оставьте 0, если биллинг не применяется.",
      "submitting": "Создание…",
      "submit": "Создать компанию",
      "saveFailed": "Не удалось создать компанию. Пожалуйста, попробуйте снова.",
      "successTitle": "Компания создана",
      "successHint": "Передайте данные ниже новому администратору. Пароль больше не будет показан.",
      "credentials": {
        "company": "Компания",
        "slug": "Идентификатор",
        "adminPassword": "Пароль администратора"
      },
      "copyPassword": "Копировать пароль",
      "toasts": {
        "copied": "Пароль скопирован.",
        "copyFailed": "Не удалось скопировать."
      },
      "slugError": "Идентификатор может содержать только строчные буквы, цифры и дефисы.",
      "namePlaceholder": "например Acme Corp",
      "slugPlaceholder": "acme-corp"
    },
    "editCompanyDialog": {
      "titleEdit": "Изменить компанию — {{name}}",
      "companyNameLabel": "Название компании",
      "slugLabel": "Идентификатор (только для чтения)",
      "statusHint": "Статус (используйте «Приостановить» / «Восстановить» в списке)",
      "monthlyRateLabel": "Месячный тариф (AMD)",
      "monthlyRateHelp": "Оставьте 0, если биллинг не применяется.",
      "saveFailed": "Не удалось сохранить. Пожалуйста, попробуйте снова.",
      "telegramLabel": "Telegram-группа",
      "telegramNone": "Не подключена",
      "telegramInactiveSuffix": "(бот удалён)",
      "telegramHelp": "Добавьте @SensefaceBot в Telegram-группу клиента — в течение минуты она появится в этом списке.",
      "telegramLocaleLabel": "Язык уведомлений",
      "telegramTest": "Отправить тестовое сообщение",
      "telegramTesting": "Отправка…",
      "telegramTestHint": "Сначала сохраните изменения, потом отправьте тест.",
      "telegramTestSuccess": "Тестовое сообщение отправлено — проверьте группу.",
      "telegramTestFailed": "Не удалось отправить тестовое сообщение."
    },
    "devices": {
      "title": "Устройства",
      "subtitle": "Терминалы по всем компаниям",
      "addNew": "+ Новое устройство",
      "searchPlaceholder": "Поиск по серийному номеру / имени…",
      "failedToLoad": "Не удалось загрузить устройства",
      "empty": "Устройств пока нет",
      "emptyHint": "Нажмите + Новое устройство для регистрации первого.",
      "filters": {
        "allCompanies": "Все компании",
        "allStatuses": "Все статусы",
        "active": "Активно",
        "inactive": "Неактивно"
      },
      "columns": {
        "serial": "Серийный номер",
        "name": "Имя",
        "company": "Компания",
        "status": "Статус",
        "created": "Создано",
        "actions": "Действия"
      },
      "badges": {
        "active": "Активно",
        "inactive": "Неактивно"
      },
      "actions": {
        "edit": "Изменить",
        "deactivate": "Деактивировать",
        "deactivating": "Деактивация…",
        "activate": "Активировать",
        "activating": "Активация…",
        "delete": "Удалить"
      },
      "toasts": {
        "created": "Устройство создано.",
        "activated": "Устройство активировано.",
        "deactivated": "Устройство деактивировано.",
        "toggleFailed": "Не удалось обновить статус устройства. Пожалуйста, попробуйте снова.",
        "deleted": "Устройство удалено.",
        "deleteFailed": "Не удалось удалить устройство. Пожалуйста, попробуйте снова.",
        "assignCompanyFirst": "Сначала назначьте устройству компанию («Редактировать»), затем активируйте."
      },
      "confirm": {
        "deactivate": "Деактивировать устройство {{name}}?",
        "delete": "Удалить устройство {{name}}?"
      },
      "noCompany": "Без компании — назначьте в «Редактировать»"
    },
    "createDeviceDialog": {
      "title": "Новое устройство",
      "companyLabel": "Компания *",
      "companyPlaceholder": "Выбрать компанию",
      "serialLabel": "Серийный номер *",
      "serialPlaceholder": "например ABC123456",
      "nameLabel": "Имя устройства *",
      "namePlaceholder": "например Вход A",
      "descriptionLabel": "Описание (необязательно)",
      "descriptionPlaceholder": "Краткое примечание об устройстве…",
      "submit": "Создать устройство",
      "submitting": "Создание…",
      "saveFailed": "Не удалось создать устройство. Пожалуйста, попробуйте снова."
    },
    "editDeviceDialog": {
      "title": "Изменить устройство",
      "subtitle": "Переименуйте терминал, исправьте серийный номер или переведите его в другую компанию.",
      "companyLabel": "Компания *",
      "companyWarning": "При переводе в другую компанию у терминала сбрасывается владелец, удаляются команды в очереди и отвязываются сотрудники прежней компании. История посещаемости остаётся у прежней компании.",
      "serialLabel": "Серийный номер *",
      "serialHint": "Должен совпадать с SN, который сообщает терминал, иначе устройство снова зарегистрируется как ожидающее.",
      "nameLabel": "Имя устройства",
      "descriptionLabel": "Описание",
      "save": "Сохранить",
      "saving": "Сохранение…",
      "saved": "Устройство обновлено.",
      "saveFailed": "Не удалось обновить устройство. Пожалуйста, попробуйте снова.",
      "moved": "Устройство переведено в компанию «{{company}}»."
    },
    "users": {
      "title": "Пользователи",
      "subtitle": "Веб-пользователи по всем компаниям",
      "addNew": "+ Новый пользователь",
      "searchPlaceholder": "Поиск по имени / email…",
      "failedToLoad": "Не удалось загрузить пользователей",
      "empty": "Пользователей пока нет",
      "emptyHint": "Нажмите + Новый пользователь для создания первого аккаунта.",
      "filters": {
        "allCompanies": "Все компании",
        "allRoles": "Все роли",
        "allStatuses": "Все статусы",
        "active": "Активен",
        "inactive": "Неактивен"
      },
      "columns": {
        "name": "Имя",
        "email": "Email",
        "role": "Роль",
        "company": "Компания",
        "status": "Статус",
        "created": "Создан",
        "actions": "Действия"
      },
      "badges": {
        "active": "Активен",
        "inactive": "Неактивен",
        "user": "Пользователь",
        "admin": "Администратор",
        "super_admin": "Суперадмин",
        "platform_admin": "Платформ-Админ"
      },
      "actions": {
        "deactivate": "Деактивировать",
        "deactivating": "Деактивация…",
        "activate": "Активировать",
        "activating": "Активация…",
        "delete": "Удалить",
        "edit": "Изменить"
      },
      "toasts": {
        "created": "Пользователь создан.",
        "activated": "Пользователь активирован.",
        "deactivated": "Пользователь деактивирован.",
        "toggleFailed": "Не удалось обновить статус пользователя. Пожалуйста, попробуйте снова.",
        "deleted": "Пользователь удалён.",
        "deleteFailed": "Не удалось удалить пользователя. Пожалуйста, попробуйте снова."
      },
      "confirm": {
        "deactivate": "Деактивировать пользователя {{name}}?",
        "delete": "Удалить пользователя {{name}}? Это нельзя отменить."
      },
      "errors": {
        "cannotTogglePlatformAdmin": "Аккаунты платформ-администраторов нельзя деактивировать.",
        "cannotToggleSelf": "Нельзя деактивировать собственный аккаунт."
      }
    },
    "editUserDialog": {
      "title": "Изменить пользователя",
      "nameLabel": "Имя",
      "roleLabel": "Роль",
      "companyLabel": "Компания",
      "passwordLabel": "Новый пароль",
      "passwordPlaceholder": "Оставьте пустым, чтобы не менять",
      "passwordHint": "Минимум 8 символов. Заполняйте только для смены.",
      "save": "Сохранить",
      "saving": "Сохранение…",
      "saved": "Пользователь обновлён.",
      "saveFailed": "Не удалось обновить пользователя. Попробуйте снова."
    },
    "createUserDialog": {
      "title": "Новый пользователь",
      "companyLabel": "Компания *",
      "companyPlaceholder": "Выбрать компанию",
      "nameLabel": "Имя *",
      "namePlaceholder": "Полное имя",
      "emailLabel": "Email *",
      "emailPlaceholder": "user@example.com",
      "passwordLabel": "Пароль",
      "passwordPlaceholder": "Минимум 8 символов",
      "autoGenerateLabel": "Сгенерировать пароль автоматически",
      "roleLabel": "Роль *",
      "submit": "Создать пользователя",
      "submitting": "Создание…",
      "saveFailed": "Не удалось создать пользователя. Пожалуйста, попробуйте снова.",
      "successTitle": "Пользователь создан",
      "successHint": "Передайте сгенерированный пароль новому пользователю. Он больше не будет показан.",
      "credentials": {
        "name": "Имя",
        "email": "Email",
        "password": "Сгенерированный пароль"
      },
      "copyPassword": "Копировать пароль",
      "toasts": {
        "copied": "Пароль скопирован.",
        "copyFailed": "Не удалось скопировать."
      },
      "suspendedSuffix": " (приостановлена)"
    },
    "billing": {
      "title": "Биллинг",
      "subtitle": "Начисления, платежи и задолженность по компаниям",
      "searchPlaceholder": "Поиск компаний…",
      "failedToLoad": "Не удалось загрузить данные биллинга",
      "empty": "Компании не найдены",
      "emptySearch": "По вашему запросу ничего не найдено.",
      "columns": {
        "company": "Компания",
        "rate": "Тариф/мес",
        "devices": "Устройства",
        "accrued": "Начислено",
        "paid": "Оплачено",
        "outstanding": "К оплате",
        "lastPayment": "Посл. платёж",
        "actions": "Действия"
      },
      "status": {
        "credit": "переплата",
        "paidInFull": "оплачено",
        "owes": "долг"
      },
      "actions": {
        "recordPayment": "Записать платёж",
        "viewDetail": "Детали"
      },
      "recordPaymentDialog": {
        "title": "Записать платёж",
        "companyLabel": "Компания *",
        "companyPlaceholder": "Выбрать компанию",
        "amountLabel": "Сумма (AMD) *",
        "amountPlaceholder": "напр. 12500",
        "paidAtLabel": "Дата оплаты *",
        "noteLabel": "Примечание (необязательно)",
        "notePlaceholder": "Реф. банковского перевода…",
        "submit": "Записать платёж",
        "submitting": "Запись…",
        "saveFailed": "Не удалось записать платёж. Попробуйте снова.",
        "toasts": {
          "recorded": "Платёж записан.",
          "recordFailed": "Не удалось записать платёж."
        },
        "errors": {
          "amountTooLow": "Сумма должна быть не менее 1 AMD.",
          "dateInFuture": "Дата не может быть в будущем.",
          "idempotencyCollision": "Этот платёж уже был записан."
        }
      },
      "voidPaymentDialog": {
        "title": "Аннулировать платёж",
        "message": "Аннулировать платёж {{amount}} от {{date}}? Запись сохранится, но не будет учитываться в итогах.",
        "reasonLabel": "Причина (необязательно)",
        "reasonPlaceholder": "напр. введено по ошибке",
        "submit": "Аннулировать",
        "submitting": "Аннулирование…",
        "toasts": {
          "voided": "Платёж аннулирован.",
          "voidFailed": "Не удалось аннулировать."
        }
      },
      "invoice": {
        "number": "Счёт №",
        "downloadPdf": "Скачать PDF",
        "emailSent": "Отправлено {{date}}",
        "emailPending": "Ожидает",
        "emailNoRecipients": "Нет получателей",
        "resend": "Повторить",
        "resendConfirmTitle": "Отправить счёт повторно?",
        "resendConfirmBody": "Все администраторы {{company}} получат новое письмо с PDF счёта.",
        "resendSuccess": "Письмо поставлено в очередь на отправку",
        "resendError": "Не удалось поставить в очередь. Попробуйте снова.",
        "downloadError": "Не удалось скачать PDF. Попробуйте снова."
      },
      "detail": {
        "backLink": "Назад к биллингу",
        "monthlyRate": "Месячный тариф",
        "billingStarted": "Биллинг с",
        "noBillingStart": "Не указано",
        "totalsSection": "Итоги",
        "totalAccrued": "Начислено",
        "totalPaid": "Оплачено",
        "outstanding": "К оплате",
        "invoicesSection": "Счета",
        "paymentsSection": "Платежи",
        "noInvoices": "Счетов пока нет.",
        "noPayments": "Платежей пока нет.",
        "invoiceColumns": {
          "period": "Период",
          "devices": "Устройства",
          "rate": "Тариф",
          "amount": "Сумма",
          "created": "Создан"
        },
        "paymentColumns": {
          "datePaid": "Дата оплаты",
          "amount": "Сумма",
          "note": "Примечание",
          "recordedBy": "Записал",
          "status": "Статус",
          "actions": "Действия"
        },
        "paymentStatus": {
          "active": "Активен",
          "voided": "Аннулирован"
        },
        "voidedReason": "Причина аннулирования",
        "actions": {
          "void": "Аннулировать",
          "voided": "Аннулирован"
        },
        "failedToLoad": "Не удалось загрузить данные биллинга."
      },
      "companyFields": {
        "monthlyRateLabel": "Месячный тариф (AMD)",
        "monthlyRateHelp": "Оставьте 0, если биллинг не применяется."
      }
    },
    "invoices": {
      "title": "Счета",
      "subtitle": "Все выставленные счета",
      "failedToLoad": "Не удалось загрузить счета",
      "empty": "Счетов пока нет",
      "emptyHint": "Счета генерируются автоматически 1-го числа каждого месяца",
      "emptyFiltered": "Ни один счёт не соответствует выбранным фильтрам",
      "filters": {
        "allCompanies": "Все компании",
        "allStatuses": "Все статусы",
        "monthLabel": "Месяц",
        "statusLabel": "Статус email",
        "companyLabel": "Компания",
        "clear": "Очистить"
      },
      "columns": {
        "number": "Счёт №",
        "company": "Компания",
        "period": "Период",
        "devices": "Устройства",
        "rate": "Тариф",
        "amount": "Сумма",
        "status": "Статус",
        "actions": "Действия"
      },
      "status": {
        "sent": "Отправлен",
        "pending": "Ожидает",
        "noRecipients": "Нет получателей"
      }
    },
    "telegramChats": {
      "title": "Telegram-чаты",
      "subtitle": "Группы, куда добавлен бот — список обновляется автоматически в течение минуты",
      "empty": "Чатов пока нет",
      "emptyHint": "Добавьте @SensefaceBot в Telegram-группу клиента — она появится здесь в течение минуты.",
      "failedToLoad": "Не удалось загрузить чаты",
      "columns": {
        "title": "Группа",
        "chatId": "Chat ID",
        "status": "Статус",
        "company": "Компания",
        "updated": "Обновлено"
      },
      "statusActive": "Бот в чате",
      "statusRemoved": "Бот удалён",
      "notAttached": "Не привязан",
      "attachHint": "Привязка чата к компании здесь включает её уведомления; язык задаётся в Компании → Изменить → Telegram.",
      "attachSuccess": "Привязка обновлена.",
      "attachFailed": "Не удалось обновить привязку.",
      "confirmReplace": "«{{company}}» уже привязана к группе «{{chat}}». Заменить на эту группу?",
      "live": "обновляется само",
      "deleteAria": "Удалить чат",
      "confirmDelete": "Убрать группу «{{chat}}» из списка? Если она привязана к компании, уведомления этой компании отключатся.",
      "deleteSuccess": "Чат удалён.",
      "deleteFailed": "Не удалось удалить чат."
    },
    "nav": {
      "clients": "Клиенты",
      "finance": "Финансы",
      "communication": "Связь"
    },
    "overview": {
      "title": "Обзор",
      "subtitle": "Ключевые показатели всей платформы",
      "tiles": {
        "companies": "Компании",
        "companiesHint": "активных: {{active}}",
        "devices": "Терминалы",
        "devicesHint": "подключено по всем компаниям",
        "outstanding": "Задолженность",
        "outstandingHint": "месячная ставка всего: {{rate}}",
        "newRequests": "Новые заявки",
        "newRequestsHint": "из формы на лендинге"
      },
      "debtors": {
        "title": "Должники",
        "empty": "Всё оплачено",
        "lastPayment": "последний платёж:",
        "viewAll": "Открыть биллинг"
      },
      "requests": {
        "title": "Последние заявки",
        "empty": "Новых заявок нет",
        "viewAll": "Все заявки"
      }
    }
  }
}
